import { c as _c } from "react/compiler-runtime";
import { Div, StyledUtilsProps } from './helpers/StyledUtils';
export const MetadataGrid = t0 => {
  const $ = _c(9);
  let embedded;
  let props;
  if ($[0] !== t0) {
    const {
      embedded: t1,
      ...t2
    } = t0;
    props = t2;
    embedded = t1 === undefined ? false : t1;
    if (embedded) {
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          align: "center",
          justify: "space-between",
          gap: 2
        };
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      props.flex = t3;
    } else {
      props.grid = props.grid || {
        columns: "45% 55%"
      };
    }
    $[0] = t0;
    $[1] = embedded;
    $[2] = props;
  } else {
    embedded = $[1];
    props = $[2];
  }
  const t1 = embedded ? 4 : 0;
  let t2;
  if ($[4] !== t1) {
    t2 = {
      y: t1
    };
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2) {
    t3 = <Div p={t2} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};